import { FileCardWrapper } from '@/components/modules/Documentation/components/DocumentationDetails/components/UploadFileManager/components/FileCardWrapper';
import { getMimeTypeIconNameByType } from '@/components/modules/Documentation/components/DocumentationDetails/components/UploadFileManager/utils/getMimeTypeIconNameByType';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const UploadedFileCard = ({ file }: { file: { name: string; mimeType: string; path: string } }) => {
  const { palette } = useCustomTheme();

  return (
    <FileCardWrapper>
      <FlexRow justifyContent={'flex-start'}>
        <Icon>{getMimeTypeIconNameByType(file.mimeType)}</Icon>
        <Font variant={'caption'}>{file.name}</Font>
      </FlexRow>
      <Icon color={palette.primary.main} size={24}>
        check_circle
      </Icon>
    </FileCardWrapper>
  );
};
